import React, { Component } from "react";
import Signbutton from "../forms/button";

import { QueryAssistant } from "../home/home";
import Appbar from "./appbar";
import DemoCarousel from "./carsouel";

export default class Confirmation extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props.location;
    this.state = {
      message: state.message || "Something Went Wrong Please Try Again Later.",
    };
  }
  render() {
    return (
      <div className="login-container">
        {/* <QueryAssistant /> */}
        <Appbar />
        <div className="login-without-appbar">
          <DemoCarousel />
          <div className="login-right-div">
            <div
              style={{
                color: "#194b7e",
                fontSize: 24,
                marginBottom: 20,
              }}
            >
              {this.state.message}
            </div>
            <Signbutton
              buttontitle="Ok"
              onClick={() => this.props.history.push("/login")}
            />
          </div>
        </div>
      </div>
    );
  }
}
